import { requestGetEmployerList } from "@app/services/EmployerService";
import SearchCddConditionInput from "@pages/dvtjcuv/rundvtjcuv/search/SearchCddConditionInput";
import EmployerListTable, { EmployerListTableMode } from "@pages/employer/list/EmployerListTable";
import { set } from "lodash";
import React, { useState } from 'react';
import {LoadingView} from "@app/components/Loading";

const SearchEmployerPipelineManager = (props) => {
    const [searchEmployerCondition, setSearchEmployerCondition] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [employers, setEmployers] = useState([]);
    const [allEmployerIds, setAllEmployerIds] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    // const searchPipeLines = async (conditions) => {
    //     setSearchDVTJCUVPipelineCondition(conditions);
    //     const params = {
    //         search_conditions: conditions || {}
    //     }

    //     params.search_conditions.is_search_by_employer = true
    //     params.search_conditions.unlimited = true

    //     // setShowSearchConditionModal(false)
    //     setLoading(true)

    //     const res = await requestGetDVTJCUVPipeLineList(params);

    //     setLoading(false)
    //     const resContent = res.content
    //     const items = resContent.pipelines.map((item, index) => {
    //         // item.no = (resContent.page - 1) * DEFAULT_PAGE_SIZE + index + 1
    //         item.no = index + 1
    //         return item
    //     });
    //     setPipeLineList(items);
    // }

    // const onShowEditItem = (item, fromReferee) => {
    //     item.fromReferee = !!fromReferee
    //     setSelectRow({...item})
    //     setShowUpdateModal(true)
    // }

    // const onCloseUpdatePipeLine = async (reload) => {
    //     setShowUpdateModal(false)

    //     // Xử lý ẩn hiện button add pipeline trên màn hình input referee.
    //     // setShowBtnAddPipelineOnRefereeInput(!reload)

    //     if (reload) {
    //         await searchPipeLines()
    //     }
    // }

    const searchEmployerList = (condition) => {
        const newSearchCons = {
            ...searchEmployerCondition,
            ...condition
        }
        setSearchEmployerCondition(newSearchCons);
        setLoading(true)

        // let params = {page: page, size: DEFAULT_PAGE_SIZE}
        let params = {search_conditions: newSearchCons}
        requestGetEmployerList(params). then((res) => {
            const items = res.content.employers.map((item, index) => {
                // item.no = (res.content.page - 1) * DEFAULT_PAGE_SIZE + index + 1
                item.no = index + 1
                return item
            });
            setEmployers(items);
            setAllEmployerIds(res.content.all_employer_ids);
            setTotalCount(res.content.totalCount)
            // setCurrentPage(res.content.page)
            // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
            setEmployers([]);
            setAllEmployerIds([]);
            setTotalCount(0)
            // setNumberPages(0);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h3 className="card-title text-bold">Tìm kiếm Employers ({employers.length})</h3>
                    <div className="card-tools">
                        {/* <div className="ml-2 float-right">
                            <button
                                onClick={() => setShowSearchConditionModal(true)}
                                type={"button"}
                                className={'btn btn-default'}>
                                Search theo khoảng
                            </button>
                        </div> */}
                        <SearchCddConditionInput
                            noPaging
                            notShowBtnSearchByCandidates
                            // parentTabId={parentTabId}
                            // tabId={tabId}
                            mode={'search-employer'}
                            onSearching={() => {
                                setLoading(true)
                            }}
                            onSearchPipelineResult={(pipelines, total) => {
                                setLoading(false)
                                
                                const employerIds = []
                                // Get employer_ids from pipelines
                                pipelines.forEach((p) => {
                                    if (p.employer_id && !employerIds.includes(p.employer_id)) {
                                        employerIds.push(p.employer_id)
                                    }
                                });
                                searchEmployerList({employer_ids: employerIds})
                            }}/>
                    </div>
                </div>
                <div className="card-body">
                    {/* <DVTJCUVPipelineTableList pipeLines={pipeLineList}
                                              hideColumns={[]}
                                              mode={DVTJCUVPipelineListMode.DVTJCUV_SEARCH_EMPLOYER}
                                              onEditItem={(selectItem, fromReferee) => onShowEditItem(selectItem, fromReferee)}
                                              onClose={(reload) => onCloseUpdatePipeLine(reload)}
                    /> */}
                    <EmployerListTable employers={employers}
                                           allEmployerIds={allEmployerIds}
                                           totalCount={totalCount}
                                           mode={EmployerListTableMode.DVTJCUV_SEARCH_EMPLOYER}
                                           searchTitle={'Search theo kho Employer'}
                                           onSearch={(condition) => searchEmployerList(condition)}/>
                    {isLoading &&
                        <LoadingView />
                    }
                </div>
            </div>
            {/* <UpdateDVTJCUVPipelineModal isShow={showUpdateModal}
                                        pipeLineInfo={selectRow}
                                        onClose={(reload) => onCloseUpdatePipeLine(reload)}
            /> */}
            {/* <SearchEmployerPipelineModal
                isShow={showSearchConditionModal}
                onClose={() => setShowSearchConditionModal(false)}
                searchInput={searchDVTJCUVPipelineCondition}
                onSearch={(conditions) => searchPipeLines(conditions)}/> */}

        </>
    )
}

export default SearchEmployerPipelineManager;
